import template_formatter from "./templateFormatter.js";
function format(value, caret, formatter) {
  typeof formatter == "string" && (formatter = template_formatter(formatter));
  var _ref = formatter(value) || {}, text = _ref.text, template = _ref.template;
  if (text === void 0 && (text = value), template)
    if (caret === void 0)
      caret = text.length;
    else {
      for (var index = 0, found = !1, possibly_last_input_character_index = -1; index < text.length && index < template.length; ) {
        if (text[index] !== template[index]) {
          if (caret === 0) {
            found = !0, caret = index;
            break;
          }
          possibly_last_input_character_index = index, caret--;
        }
        index++;
      }
      found || (caret = possibly_last_input_character_index + 1);
    }
  return {
    text,
    caret
  };
}
export {
  format as default
};
//# sourceMappingURL=format.js.map
